// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductSelector from "@insite/content-library/Components/ProductSelector";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block/Block";
import { orderProps } from "@store/Themes/common/props/order";
import constants from "@store/constants";
import updateChangeRequestOrder from "@store/Framework/Store/Greif/Pages/RequestOrderChange/Handler/UpdateChangeRequestOrder";
import {
    AddedItemModel,
    ChangeRequestModel,
} from "@store/Library/Widgets/RequestOrderChange/RequestOrderChangePageContainer";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const settingsCollection = getSettingsCollection(state);

    return {
        showAddToCartConfirmationDialog: settingsCollection.productSettings.showAddToCartConfirmationDialog,
        changeRequestOrder: state.greif.pages.orderChange.changeRequestOrder,
    };
};

const mapDispatchToProps = {
    updateChangeRequestOrder,
};

export type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestOrderChangeQuickAddStyles {
    block?: BlockProps;
    heading?: TypographyPresentationProps;
    addItemText?: TypographyPresentationProps;
    selectorWrapper?: InjectableCss;
}

export const requestOrderChangeQuickAddStyles: RequestOrderChangeQuickAddStyles = {
    block: { ...orderProps.block, variantSide: "bottom" },
    heading: {
        variant: "h4",
    },
    selectorWrapper: {
        css: css`
            margin-top: ${pxToRem(16)};
        `,
    },
};

const styles = requestOrderChangeQuickAddStyles;

export const RequestOrderChangeQuickAdd = ({ updateChangeRequestOrder, changeRequestOrder }: Props) => {
    const [errorMessage, setErrorMessage] = useState<React.ReactNode>("");

    const addProductToCart = (productInfos: ProductInfo, product: ProductModel) => {
        const checkIfProductExist = changeRequestOrder?.newLines?.find(p => p.product.id === product.id);

        if (checkIfProductExist && changeRequestOrder) {
            let checkLines = changeRequestOrder?.newLines;
            const productQty = Number(checkIfProductExist.newQuantity) + productInfos.qtyOrdered;

            const productObject: AddedItemModel = {
                productInfo: productInfos,
                product,
                changeNotes: checkIfProductExist.changeNotes || "",
                newQuantity: productQty,
                changeReason: checkIfProductExist.changeReason || "New Product",
            };

            checkLines = changeRequestOrder?.newLines?.map(line =>
                line.product.id === product.id ? productObject : line,
            );

            const updatedLineAdd: ChangeRequestModel = {
                ...changeRequestOrder,
                newLines: checkLines,
            };
            updateChangeRequestOrder({ changeRequestOrder: updatedLineAdd });
        } else {
            const productObject: AddedItemModel = {
                productInfo: productInfos,
                product,
                changeNotes: "",
                newQuantity: productInfos.qtyOrdered,
                changeReason: "New Product",
            };

            const newLineAdd: ChangeRequestModel = {
                ...changeRequestOrder,
                newLines: [...(changeRequestOrder.newLines || []), productObject],
            };
            updateChangeRequestOrder({ changeRequestOrder: newLineAdd });
        }
    };

    return (
        <Block {...styles.block}>
            <Typography {...styles.heading}>{translate("Add items to your order")}</Typography>
            <Typography {...styles.addItemText}>{siteMessage("OrderChange_AddItemText")}</Typography>
            <StyledWrapper {...styles.selectorWrapper} data-test-selector="requestOrderChangeQuickAddWidget">
                <ProductSelector
                    selectButtonTitle={translate("Add to order")}
                    onSelectProduct={addProductToCart}
                    productIsConfigurableMessage={siteMessage("RequestOrderChangeQuickAdd_CannotOrderConfigurable")}
                    productIsUnavailableMessage={siteMessage("RequestOrderChangeQuickAdd_ProductIsUnavailable")}
                    customErrorMessage={errorMessage}
                    data-test-selector="requestOrderChangeQuickAddWidget_addToCart"
                />
            </StyledWrapper>
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestOrderChangeQuickAdd),
    definition: {
        group: constants.widgetGroup.orderChangeRequest,
        allowedContexts: ["OrderChangeRequestPage" as any],
        displayName: "Change Request Add Items",
    },
};

export default widgetModule;
